export var clientLifeCycleDetailsMapper = function (response) {
    if (response) {
        return {
            requestid: response.requestid,
            success: response.success,
            message: response.message,
            statuscode: response.statuscode,
            errors: response.errors,
            currentpage: response.currentpage,
            pagesize: response.pagesize,
            totalpages: response.totalitems,
            totalitems: response.totalitems,
            orderby: response.orderby,
            orderbydesc: response.orderbydesc,
            data: response.data.map(function (item) {
                return {
                    aopdate: item.aopdate,
                    firstcalldate: item.firstcalldate,
                    firstmeetingdate: item.firstmeetingdate,
                    onboardingdate: item.onboardingdate,
                    onboardingtatcolor: item.onboardingtatcolor,
                    profilingfirstdate: item.profilingfirstdate,
                    demodate: item.demodate,
                    rmmappingfirstdate: item.rmmappingfirstdate,
                    fristpayingdate: item.fristpayingdate,
                    firstinvestmentdate: item.firstinvestmentdate,
                    lastprofilingdate: item.lastprofilingdate,
                    activationtat: item.activationtat,
                    activationtatcolor: item.activationtatcolor,
                    noofproducts: item.noofproducts,
                    emtdownload: item.emtdownload,
                    engagementscore: item.engagementscore,
                    walletshare: item.walletshare,
                    rvpenetration: item.rvpenetration,
                    tatmeeting: item.tatmeeting,
                    tatcalling: item.tatcalling,
                    tatmeetcolour: item.tatmeetcolour,
                    tatcallcolour: item.tatcallcolour,
                    lastcalldate: item.lastcalldate,
                    lastmeetingdate: item.lastmeetingdate,
                    currentstage: item.currentstage,
                    potentialst: item.potentialst,
                    pimode: item.pimode,
                    actypeflag: item.actypeflag,
                    accountclosedate: item.accountclosedate,
                    profilingper: item.profilingper,
                    isClientProfilerShow: item.isClientProfilerShow,
                    onboardinG_PER: item.onboardinG_PER,
                };
            }),
        };
    }
    return {};
};
